module.exports = __webpack_public_path__ + "img/img1.b2e48bb5.jpg";